import {BasePage} from "peggirkit";
import React, {useState} from "react";
import {useIntl} from "react-intl";
import PosTopBar from "./PosTopBar";
import {Outlet} from "react-router";
import PosProvider from "@/context/pos/PosProvider";
import EmployeeModal from "@widgets/timeRegistration/EmployeeModal";

const PosLayout = () => {
    const intl = useIntl();
    const [showTimeRegistration, setShowTimeRegistration] = useState(false);

    return (
        <BasePage
            title={intl.formatMessage({id: "pos"})}
            appName={intl.formatMessage({id: "appName"})}
        >
            <PosProvider>
                <div className={"h-dvh flex flex-col bg-gray-100 dark:bg-slate-900"}>
                    <PosTopBar setShowTimeRegistration={setShowTimeRegistration}/>

                    <main className={"flex-1 min-h-0"}>
                        <Outlet/>
                    </main>
                </div>
            </PosProvider>

            <EmployeeModal
                show={showTimeRegistration}
                setShow={setShowTimeRegistration}
            />
        </BasePage>
    );
};

export default PosLayout;